const GAMES = [];

export default GAMES;
